export enum Protocol {
    http,
    https
}
